export const findingsContent = {
  eyebrow: "KEY AUDIT FINDINGS",
  title: "3 Critical Structural Bottlenecks in Roofing Sales Operations",
  points: [
    {
      title: "The Weekend & After-Hours Black Hole (64.2% of Total Leakage):",
      before:
        "Inquiries submitted after 6:00 PM on weekdays or anytime on weekends experience an average response delay of ",
      emphasis: "14 hours and 38 minutes",
      after: ". By Monday 9:00 AM, 78% of these homeowners have already engaged a competitor.",
    },
    {
      title: 'The "Voice-Only" Failure Rate:',
      before:
        "81.4% of contractors rely solely on phone callbacks. Modern homeowners (especially aged 30–50) prefer instant SMS/chat qualification. 62% of unreturned calls go straight to voicemail and are never listened to.",
    },
    {
      title: "The Field Friction Gap:",
      before:
        "During peak business hours (11:00 AM – 3:00 PM), response times drop by 310% because business owners and estimators are actively driving or up on roofs, unable to process web forms in real time.",
    },
  ],
}
